<template>
  <div>
    <v-simple-table light>
      <thead>
      <tr>
        <th class="text-left">Product</th>
        <th class="text-right">Price</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="state.member.meeting.registrationSelected">
        <td class="text-left">
          {{ state.member.meeting.registrationSelected.name }}
        </td>
        <td class="text-right">
          {{
            new Intl.NumberFormat('en-US', {
              style: 'currency', currency: 'USD'
            }).format(state.member.meeting.registrationSelected.price)
          }}
        </td>
      </tr>
      <tr v-for="(item, index) in state.member.meeting.extraProductsSelected" :key="index">
        <td class="text-left">
          {{ item.name }} <span v-if="item.quantity">(x{{ item.quantity }})</span>
        </td>
        <td v-if="item.quantity" class="text-right">
          {{
            new Intl.NumberFormat('en-US', {
              style: 'currency', currency: 'USD'
            }).format(item.price * item.quantity)
          }}
        </td>
        <td v-else class="text-right">
          {{
            new Intl.NumberFormat('en-US', {
              style: 'currency', currency: 'USD'
            }).format(item.price)
          }}
        </td>
      </tr>
      <tr v-if="state.mulligan_pack.amount > 0">
        <td>Mulligan Package</td>
        <td class="text-right">
          {{
            new Intl.NumberFormat('en-US', {
              style: 'currency', currency: 'USD'
            }).format(state.mulligan_pack.amount)
          }}
        </td>
      </tr>
      <tr v-if="state.donation.amount > 0">
        <td>FVF Donation</td>
        <td class="text-right">
          {{
            new Intl.NumberFormat('en-US', {
              style: 'currency', currency: 'USD'
            }).format(state.donation.amount)
          }}
        </td>
      </tr>
      <tr>
        <td class="text-left"><strong>Total</strong></td>
        <td class="text-right"><h2>{{ formTotal }}</h2></td>
      </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: "ReviewTable",
  computed: {
    ...mapGetters({
      state: 'getState',
    }),

  },
  props: [
    'formTotal'
  ]
}
</script>

<style scoped>

</style>